<template>
  <article class="example-page">
    <h1>Modal</h1>
    <form>
      <label for="modal-title">Header</label>
      <input id="modal-title" v-model="title" type="text">
      <label for="modal-action">Header Action</label>
      <input id="modal-action" v-model="headerAction" type="text">
      <label for="modal-body">Body</label>
      <textarea id="modal-body" v-model="bodyData" class="large" />
      <label for="modal-footer">Footer</label>
      <input id="modal-footer" v-model="footerData" type="text">
      <button type="button" @click="toggle">Launch Modal!</button>
    </form>

    <!-- modal constructor -->
    <modal :title="$t(title)" :displayed="displayedData" @close="close">
      <!-- slotted action for the header -->
      <button slot="title-action" type="button">{{ headerAction }}</button>

      <!-- either create content and assign a slot OR -->
      <form v-if="!bodyData" slot="body" class="modal-body">
        <label>First Name</label>
        <input type="text" value="Aaron">
        <label>Last Name</label>
        <input type="text" value="Ailey">
        <label>Email</label>
        <input type="text" value="aaron.ailey@gmail.com">
        <label>Phone</label>
        <input type="text" value="778-888-8888">
        <label>Fee</label>
        <input type="text" value="0.45%">
        <p>The client will be notified of any changes you make on their profile.</p>
      </form>

      <!-- OR bind data into a sloted template -->
      <template v-if="bodyData" slot="body">
        <!-- eslint-disable vue/no-v-html -->
        <p class="modal-body" v-html="bodyData" />
        <!-- eslint-enable vue/no-v-html -->
      </template>

      <!-- OR both -->
      <template slot="footer">
        <!-- eslint-disable vue/no-v-html -->
        <span @click="close" v-html="footerData" />
        <!-- eslint-enable vue/no-v-html -->
      </template>
    </modal>
    <!-- end modal -->
  </article>
</template>

<script>
import { modal } from '@/components/layout';

const defaultBodyData = 'This data is bound in via <code>template</code>, it can be any valid HTML. If you <strong>delete</strong> the contents of the "Body" the modal form hard coded on this page will appear!';

export default {
  components: { modal },
  data() {
    return {
      displayedData: false,
      title: 'Aaron Ailey',
      headerAction: 'Invite Client',
      bodyData: defaultBodyData,
      footerData: '<button>Confirm</button>',
    };
  },
  methods: {
    toggle() {
      this.displayedData = !this.displayedData;
    },
    close() {
      this.displayedData = false;
    },
  },
};
</script>

<style lang="scss" scoped>


  .modal-body {
    padding: 0.5rem;
  }
</style>
